import { createIcon } from '~/utils';

export const EllipseIcon = createIcon({
  viewBox: '0 0 8 8',
  path: <circle cx='4' cy='4' r='3.5' />,
});
